/* eslint-disable max-lines-per-function */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "darkColors", {
    enumerable: true,
    get: ()=>darkColors
});
const _merge = /*#__PURE__*/ _interopRequireDefault(require("lodash/merge"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const darkColors = (colors, overrides)=>(0, _merge.default)({
        homepage: {
            text: colors.white,
            icon: colors.primary
        },
        range_bar: {
            dots_unreached: colors.light,
            dots_text: colors.white,
            unfilled_track: colors.light,
            dots_reached: colors.primary,
            filled_track: colors.primary
        },
        sub_navigation: {
            icon: colors.primary,
            background: colors.dark,
            text: colors.primary
        },
        top_navigation: {
            icon: colors.primary,
            background: colors.dark,
            divider: colors.black,
            text: colors.primary
        },
        bottom_navigation: {
            background: colors.black,
            border: colors.dark,
            active_icon_color: colors.primary,
            inactive_icon_color: colors.secondary
        },
        item_card: {
            box_background: colors.black,
            box_border: colors.black,
            box_paragraph_text: colors.white,
            heart_filled_icon_color: colors.red,
            heart_empty_icon_color: colors.red,
            star_icon_color: colors.primary
        },
        form: {
            input_label: '#FFFFFF',
            input_text: colors.white,
            input_background: colors.dark,
            input_border: colors.black,
            input_placeholder: colors.light,
            input_checkbox_background: colors.black,
            input_checkbox_border: colors.dark,
            input_checkbox_icon: colors.primary,
            input_checkbox_icon_checked_background: colors.dark
        },
        auth: {
            background: colors.dark,
            text: '#FFFFFF',
            pad_placeholder: colors.light,
            pad_text: colors.white,
            icon: colors.primary,
            signature_background: colors.dark,
            signature_text: colors.white,
            auth_button_background: colors.primary
        },
        menu: {
            background: colors.dark,
            icon: colors.primary,
            card_background: colors.dark,
            card_text: colors.white,
            card_border: colors.dark
        },
        profile: {
            text: colors.white,
            icon: colors.primary,
            divider: colors.secondary
        },
        store: {
            text: colors.white,
            background: colors.dark,
            link_text: colors.white,
            link_border: colors.black,
            link_background: colors.dark
        },
        rewards: {
            text: colors.white
        },
        offers: {
            icon: colors.primary,
            text: colors.white,
            button_earn_background: colors.dark,
            button_earn_text: colors.primary,
            refer_button: colors.primary,
            expires_at: colors.white
        },
        milestones: {
            text: colors.white,
            icon: colors.primary
        },
        subscriptions: {
            text: colors.white,
            icon: colors.primary
        },
        subs_pop_ups: {
            text: colors.white,
            icon: colors.primary,
            background: colors.primary,
            background_warning: colors.danger,
            button_background: colors.primary,
            button_background_warning: colors.white,
            button_text: colors.white,
            button_text_warning: colors.danger
        },
        gift_card: {
            card_color: colors.primary,
            card_color_muted: colors.secondary,
            card_text_color: colors.white,
            icon: colors.white,
            convert_points_border: colors.primary,
            convert_points_text: colors.primary
        },
        messages: {
            text: colors.white,
            icon: colors.dark,
            slider_counter_background: colors.dark,
            slider_counter: colors.gray,
            slider_dots_background: colors.dark,
            slider_dots: colors.gray,
            link_box_border: colors.primary,
            link_box_background: colors.dark,
            link_box_icon_background: colors.primary,
            link_box_icon: colors.primary,
            link_box_link_text: colors.primary
        },
        refer: {
            icon: colors.primary,
            qr_code_background: colors.white,
            qr_code_color: colors.black,
            text: colors.white,
            social_facebook_icon_color: '#3b5998',
            social_twitter_icon_color: '#FFFFFF',
            social_linkedin_icon_color: '#0077b5',
            social_instagram_icon_color: '#e4405f',
            refer_button_background: colors.primary
        },
        general: {
            link: colors.primary,
            text: '#FFFFFF',
            divider: colors.black,
            spinner_background: colors.primary,
            spinner_icon: colors.white,
            screen_background: colors.black,
            section_background: colors.dark,
            button_background: colors.primary,
            button_text: colors.white,
            button_neutral_background: colors.dark,
            button_neutral_text: colors.primary,
            button_danger_background: colors.red,
            button_danger_text: colors.white
        },
        account_history: {
            text: colors.white,
            icon: colors.primary,
            active_button_background: colors.primary,
            active_button_text: colors.white,
            inactive_button_background: colors.dark,
            inactive_button_text: colors.white
        },
        account_information: {
            icon: colors.primary
        },
        account_settings: {
            text: colors.white,
            swipe_active_background: colors.primary,
            swipe_inactive_background: colors.white,
            thumb_active_background: colors.white,
            thumb_inactive_background: colors.white
        },
        modal: {
            text: colors.white,
            icon: colors.primary,
            overlay_background: colors.transparencyDark,
            background: colors.black,
            header_background: colors.black,
            body_background: colors.dark,
            footer_background: colors.black,
            button_background: colors.primary,
            button_text: colors.white,
            button_icon: colors.white
        },
        native_app_subscriptions: {
            header_color: colors.primary,
            header_icon: colors.white,
            scroll_view_color: '#f0f0f0',
            card_color: colors.white,
            button_color: colors.primary
        },
        no_data_place_holder: {
            icon: colors.primary,
            card_background: colors.dark
        }
    }, overrides);
